import * as Types from '../../../../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Wed Dec 03 2025 16:37:29 GMT+0000 (Coordinated Universal Time)
*/

const defaultOptions = {} as const;
export type GetAlternateAudioLocalizationsQueryVariables = Types.Exact<{
  mediaHashedId: Types.Scalars['HashedId']['input'];
}>;


export type GetAlternateAudioLocalizationsQuery = { __typename?: 'Query', media?:
    | { __typename?: 'Audio', id: string, hashedId: string, ietfLanguageTag?: string | null | undefined, localizations: Array<{ __typename?: 'MediaLocalization', id: string, ietfLanguageTag: string, languageName: string, nativeLanguageName: string, enabled: boolean, audioProvider: string, videoProvider: string, localizationIntent: string, createdAt: string, updatedAt: string, downloadUrl?: string | null | undefined, sourceMedia?:
          | { __typename?: 'Audio', id: string }
          | { __typename?: 'Avatar', id: string }
          | { __typename?: 'Document', id: string }
          | { __typename?: 'Image', id: string }
          | { __typename?: 'LiveSharedVideo', id: string }
          | { __typename?: 'LiveStream', id: string }
          | { __typename?: 'Logo', id: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string }
          | { __typename?: 'PdfDocument', id: string }
          | { __typename?: 'Swf', id: string }
          | { __typename?: 'UnknownMedia', id: string }
          | { __typename?: 'Video', id: string }
         | null | undefined, localizedMedia?:
          | { __typename?: 'Audio', id: string, playable: boolean, name: string }
          | { __typename?: 'Avatar', id: string, playable: boolean, name: string }
          | { __typename?: 'Document', id: string, playable: boolean, name: string }
          | { __typename?: 'Image', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveSharedVideo', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveStream', id: string, playable: boolean, name: string }
          | { __typename?: 'Logo', id: string, playable: boolean, name: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'PdfDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'Swf', id: string, playable: boolean, name: string }
          | { __typename?: 'UnknownMedia', id: string, playable: boolean, name: string }
          | { __typename?: 'Video', id: string, playable: boolean, name: string }
         | null | undefined }> }
    | { __typename?: 'Avatar', id: string, hashedId: string, ietfLanguageTag?: string | null | undefined, localizations: Array<{ __typename?: 'MediaLocalization', id: string, ietfLanguageTag: string, languageName: string, nativeLanguageName: string, enabled: boolean, audioProvider: string, videoProvider: string, localizationIntent: string, createdAt: string, updatedAt: string, downloadUrl?: string | null | undefined, sourceMedia?:
          | { __typename?: 'Audio', id: string }
          | { __typename?: 'Avatar', id: string }
          | { __typename?: 'Document', id: string }
          | { __typename?: 'Image', id: string }
          | { __typename?: 'LiveSharedVideo', id: string }
          | { __typename?: 'LiveStream', id: string }
          | { __typename?: 'Logo', id: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string }
          | { __typename?: 'PdfDocument', id: string }
          | { __typename?: 'Swf', id: string }
          | { __typename?: 'UnknownMedia', id: string }
          | { __typename?: 'Video', id: string }
         | null | undefined, localizedMedia?:
          | { __typename?: 'Audio', id: string, playable: boolean, name: string }
          | { __typename?: 'Avatar', id: string, playable: boolean, name: string }
          | { __typename?: 'Document', id: string, playable: boolean, name: string }
          | { __typename?: 'Image', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveSharedVideo', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveStream', id: string, playable: boolean, name: string }
          | { __typename?: 'Logo', id: string, playable: boolean, name: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'PdfDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'Swf', id: string, playable: boolean, name: string }
          | { __typename?: 'UnknownMedia', id: string, playable: boolean, name: string }
          | { __typename?: 'Video', id: string, playable: boolean, name: string }
         | null | undefined }> }
    | { __typename?: 'Document', id: string, hashedId: string, ietfLanguageTag?: string | null | undefined, localizations: Array<{ __typename?: 'MediaLocalization', id: string, ietfLanguageTag: string, languageName: string, nativeLanguageName: string, enabled: boolean, audioProvider: string, videoProvider: string, localizationIntent: string, createdAt: string, updatedAt: string, downloadUrl?: string | null | undefined, sourceMedia?:
          | { __typename?: 'Audio', id: string }
          | { __typename?: 'Avatar', id: string }
          | { __typename?: 'Document', id: string }
          | { __typename?: 'Image', id: string }
          | { __typename?: 'LiveSharedVideo', id: string }
          | { __typename?: 'LiveStream', id: string }
          | { __typename?: 'Logo', id: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string }
          | { __typename?: 'PdfDocument', id: string }
          | { __typename?: 'Swf', id: string }
          | { __typename?: 'UnknownMedia', id: string }
          | { __typename?: 'Video', id: string }
         | null | undefined, localizedMedia?:
          | { __typename?: 'Audio', id: string, playable: boolean, name: string }
          | { __typename?: 'Avatar', id: string, playable: boolean, name: string }
          | { __typename?: 'Document', id: string, playable: boolean, name: string }
          | { __typename?: 'Image', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveSharedVideo', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveStream', id: string, playable: boolean, name: string }
          | { __typename?: 'Logo', id: string, playable: boolean, name: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'PdfDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'Swf', id: string, playable: boolean, name: string }
          | { __typename?: 'UnknownMedia', id: string, playable: boolean, name: string }
          | { __typename?: 'Video', id: string, playable: boolean, name: string }
         | null | undefined }> }
    | { __typename?: 'Image', id: string, hashedId: string, ietfLanguageTag?: string | null | undefined, localizations: Array<{ __typename?: 'MediaLocalization', id: string, ietfLanguageTag: string, languageName: string, nativeLanguageName: string, enabled: boolean, audioProvider: string, videoProvider: string, localizationIntent: string, createdAt: string, updatedAt: string, downloadUrl?: string | null | undefined, sourceMedia?:
          | { __typename?: 'Audio', id: string }
          | { __typename?: 'Avatar', id: string }
          | { __typename?: 'Document', id: string }
          | { __typename?: 'Image', id: string }
          | { __typename?: 'LiveSharedVideo', id: string }
          | { __typename?: 'LiveStream', id: string }
          | { __typename?: 'Logo', id: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string }
          | { __typename?: 'PdfDocument', id: string }
          | { __typename?: 'Swf', id: string }
          | { __typename?: 'UnknownMedia', id: string }
          | { __typename?: 'Video', id: string }
         | null | undefined, localizedMedia?:
          | { __typename?: 'Audio', id: string, playable: boolean, name: string }
          | { __typename?: 'Avatar', id: string, playable: boolean, name: string }
          | { __typename?: 'Document', id: string, playable: boolean, name: string }
          | { __typename?: 'Image', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveSharedVideo', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveStream', id: string, playable: boolean, name: string }
          | { __typename?: 'Logo', id: string, playable: boolean, name: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'PdfDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'Swf', id: string, playable: boolean, name: string }
          | { __typename?: 'UnknownMedia', id: string, playable: boolean, name: string }
          | { __typename?: 'Video', id: string, playable: boolean, name: string }
         | null | undefined }> }
    | { __typename?: 'LiveSharedVideo', id: string, hashedId: string, ietfLanguageTag?: string | null | undefined, localizations: Array<{ __typename?: 'MediaLocalization', id: string, ietfLanguageTag: string, languageName: string, nativeLanguageName: string, enabled: boolean, audioProvider: string, videoProvider: string, localizationIntent: string, createdAt: string, updatedAt: string, downloadUrl?: string | null | undefined, sourceMedia?:
          | { __typename?: 'Audio', id: string }
          | { __typename?: 'Avatar', id: string }
          | { __typename?: 'Document', id: string }
          | { __typename?: 'Image', id: string }
          | { __typename?: 'LiveSharedVideo', id: string }
          | { __typename?: 'LiveStream', id: string }
          | { __typename?: 'Logo', id: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string }
          | { __typename?: 'PdfDocument', id: string }
          | { __typename?: 'Swf', id: string }
          | { __typename?: 'UnknownMedia', id: string }
          | { __typename?: 'Video', id: string }
         | null | undefined, localizedMedia?:
          | { __typename?: 'Audio', id: string, playable: boolean, name: string }
          | { __typename?: 'Avatar', id: string, playable: boolean, name: string }
          | { __typename?: 'Document', id: string, playable: boolean, name: string }
          | { __typename?: 'Image', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveSharedVideo', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveStream', id: string, playable: boolean, name: string }
          | { __typename?: 'Logo', id: string, playable: boolean, name: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'PdfDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'Swf', id: string, playable: boolean, name: string }
          | { __typename?: 'UnknownMedia', id: string, playable: boolean, name: string }
          | { __typename?: 'Video', id: string, playable: boolean, name: string }
         | null | undefined }> }
    | { __typename?: 'LiveStream', id: string, hashedId: string, ietfLanguageTag?: string | null | undefined, localizations: Array<{ __typename?: 'MediaLocalization', id: string, ietfLanguageTag: string, languageName: string, nativeLanguageName: string, enabled: boolean, audioProvider: string, videoProvider: string, localizationIntent: string, createdAt: string, updatedAt: string, downloadUrl?: string | null | undefined, sourceMedia?:
          | { __typename?: 'Audio', id: string }
          | { __typename?: 'Avatar', id: string }
          | { __typename?: 'Document', id: string }
          | { __typename?: 'Image', id: string }
          | { __typename?: 'LiveSharedVideo', id: string }
          | { __typename?: 'LiveStream', id: string }
          | { __typename?: 'Logo', id: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string }
          | { __typename?: 'PdfDocument', id: string }
          | { __typename?: 'Swf', id: string }
          | { __typename?: 'UnknownMedia', id: string }
          | { __typename?: 'Video', id: string }
         | null | undefined, localizedMedia?:
          | { __typename?: 'Audio', id: string, playable: boolean, name: string }
          | { __typename?: 'Avatar', id: string, playable: boolean, name: string }
          | { __typename?: 'Document', id: string, playable: boolean, name: string }
          | { __typename?: 'Image', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveSharedVideo', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveStream', id: string, playable: boolean, name: string }
          | { __typename?: 'Logo', id: string, playable: boolean, name: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'PdfDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'Swf', id: string, playable: boolean, name: string }
          | { __typename?: 'UnknownMedia', id: string, playable: boolean, name: string }
          | { __typename?: 'Video', id: string, playable: boolean, name: string }
         | null | undefined }> }
    | { __typename?: 'Logo', id: string, hashedId: string, ietfLanguageTag?: string | null | undefined, localizations: Array<{ __typename?: 'MediaLocalization', id: string, ietfLanguageTag: string, languageName: string, nativeLanguageName: string, enabled: boolean, audioProvider: string, videoProvider: string, localizationIntent: string, createdAt: string, updatedAt: string, downloadUrl?: string | null | undefined, sourceMedia?:
          | { __typename?: 'Audio', id: string }
          | { __typename?: 'Avatar', id: string }
          | { __typename?: 'Document', id: string }
          | { __typename?: 'Image', id: string }
          | { __typename?: 'LiveSharedVideo', id: string }
          | { __typename?: 'LiveStream', id: string }
          | { __typename?: 'Logo', id: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string }
          | { __typename?: 'PdfDocument', id: string }
          | { __typename?: 'Swf', id: string }
          | { __typename?: 'UnknownMedia', id: string }
          | { __typename?: 'Video', id: string }
         | null | undefined, localizedMedia?:
          | { __typename?: 'Audio', id: string, playable: boolean, name: string }
          | { __typename?: 'Avatar', id: string, playable: boolean, name: string }
          | { __typename?: 'Document', id: string, playable: boolean, name: string }
          | { __typename?: 'Image', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveSharedVideo', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveStream', id: string, playable: boolean, name: string }
          | { __typename?: 'Logo', id: string, playable: boolean, name: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'PdfDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'Swf', id: string, playable: boolean, name: string }
          | { __typename?: 'UnknownMedia', id: string, playable: boolean, name: string }
          | { __typename?: 'Video', id: string, playable: boolean, name: string }
         | null | undefined }> }
    | { __typename?: 'MicrosoftOfficeDocument', id: string, hashedId: string, ietfLanguageTag?: string | null | undefined, localizations: Array<{ __typename?: 'MediaLocalization', id: string, ietfLanguageTag: string, languageName: string, nativeLanguageName: string, enabled: boolean, audioProvider: string, videoProvider: string, localizationIntent: string, createdAt: string, updatedAt: string, downloadUrl?: string | null | undefined, sourceMedia?:
          | { __typename?: 'Audio', id: string }
          | { __typename?: 'Avatar', id: string }
          | { __typename?: 'Document', id: string }
          | { __typename?: 'Image', id: string }
          | { __typename?: 'LiveSharedVideo', id: string }
          | { __typename?: 'LiveStream', id: string }
          | { __typename?: 'Logo', id: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string }
          | { __typename?: 'PdfDocument', id: string }
          | { __typename?: 'Swf', id: string }
          | { __typename?: 'UnknownMedia', id: string }
          | { __typename?: 'Video', id: string }
         | null | undefined, localizedMedia?:
          | { __typename?: 'Audio', id: string, playable: boolean, name: string }
          | { __typename?: 'Avatar', id: string, playable: boolean, name: string }
          | { __typename?: 'Document', id: string, playable: boolean, name: string }
          | { __typename?: 'Image', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveSharedVideo', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveStream', id: string, playable: boolean, name: string }
          | { __typename?: 'Logo', id: string, playable: boolean, name: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'PdfDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'Swf', id: string, playable: boolean, name: string }
          | { __typename?: 'UnknownMedia', id: string, playable: boolean, name: string }
          | { __typename?: 'Video', id: string, playable: boolean, name: string }
         | null | undefined }> }
    | { __typename?: 'PdfDocument', id: string, hashedId: string, ietfLanguageTag?: string | null | undefined, localizations: Array<{ __typename?: 'MediaLocalization', id: string, ietfLanguageTag: string, languageName: string, nativeLanguageName: string, enabled: boolean, audioProvider: string, videoProvider: string, localizationIntent: string, createdAt: string, updatedAt: string, downloadUrl?: string | null | undefined, sourceMedia?:
          | { __typename?: 'Audio', id: string }
          | { __typename?: 'Avatar', id: string }
          | { __typename?: 'Document', id: string }
          | { __typename?: 'Image', id: string }
          | { __typename?: 'LiveSharedVideo', id: string }
          | { __typename?: 'LiveStream', id: string }
          | { __typename?: 'Logo', id: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string }
          | { __typename?: 'PdfDocument', id: string }
          | { __typename?: 'Swf', id: string }
          | { __typename?: 'UnknownMedia', id: string }
          | { __typename?: 'Video', id: string }
         | null | undefined, localizedMedia?:
          | { __typename?: 'Audio', id: string, playable: boolean, name: string }
          | { __typename?: 'Avatar', id: string, playable: boolean, name: string }
          | { __typename?: 'Document', id: string, playable: boolean, name: string }
          | { __typename?: 'Image', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveSharedVideo', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveStream', id: string, playable: boolean, name: string }
          | { __typename?: 'Logo', id: string, playable: boolean, name: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'PdfDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'Swf', id: string, playable: boolean, name: string }
          | { __typename?: 'UnknownMedia', id: string, playable: boolean, name: string }
          | { __typename?: 'Video', id: string, playable: boolean, name: string }
         | null | undefined }> }
    | { __typename?: 'Swf', id: string, hashedId: string, ietfLanguageTag?: string | null | undefined, localizations: Array<{ __typename?: 'MediaLocalization', id: string, ietfLanguageTag: string, languageName: string, nativeLanguageName: string, enabled: boolean, audioProvider: string, videoProvider: string, localizationIntent: string, createdAt: string, updatedAt: string, downloadUrl?: string | null | undefined, sourceMedia?:
          | { __typename?: 'Audio', id: string }
          | { __typename?: 'Avatar', id: string }
          | { __typename?: 'Document', id: string }
          | { __typename?: 'Image', id: string }
          | { __typename?: 'LiveSharedVideo', id: string }
          | { __typename?: 'LiveStream', id: string }
          | { __typename?: 'Logo', id: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string }
          | { __typename?: 'PdfDocument', id: string }
          | { __typename?: 'Swf', id: string }
          | { __typename?: 'UnknownMedia', id: string }
          | { __typename?: 'Video', id: string }
         | null | undefined, localizedMedia?:
          | { __typename?: 'Audio', id: string, playable: boolean, name: string }
          | { __typename?: 'Avatar', id: string, playable: boolean, name: string }
          | { __typename?: 'Document', id: string, playable: boolean, name: string }
          | { __typename?: 'Image', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveSharedVideo', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveStream', id: string, playable: boolean, name: string }
          | { __typename?: 'Logo', id: string, playable: boolean, name: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'PdfDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'Swf', id: string, playable: boolean, name: string }
          | { __typename?: 'UnknownMedia', id: string, playable: boolean, name: string }
          | { __typename?: 'Video', id: string, playable: boolean, name: string }
         | null | undefined }> }
    | { __typename?: 'UnknownMedia', id: string, hashedId: string, ietfLanguageTag?: string | null | undefined, localizations: Array<{ __typename?: 'MediaLocalization', id: string, ietfLanguageTag: string, languageName: string, nativeLanguageName: string, enabled: boolean, audioProvider: string, videoProvider: string, localizationIntent: string, createdAt: string, updatedAt: string, downloadUrl?: string | null | undefined, sourceMedia?:
          | { __typename?: 'Audio', id: string }
          | { __typename?: 'Avatar', id: string }
          | { __typename?: 'Document', id: string }
          | { __typename?: 'Image', id: string }
          | { __typename?: 'LiveSharedVideo', id: string }
          | { __typename?: 'LiveStream', id: string }
          | { __typename?: 'Logo', id: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string }
          | { __typename?: 'PdfDocument', id: string }
          | { __typename?: 'Swf', id: string }
          | { __typename?: 'UnknownMedia', id: string }
          | { __typename?: 'Video', id: string }
         | null | undefined, localizedMedia?:
          | { __typename?: 'Audio', id: string, playable: boolean, name: string }
          | { __typename?: 'Avatar', id: string, playable: boolean, name: string }
          | { __typename?: 'Document', id: string, playable: boolean, name: string }
          | { __typename?: 'Image', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveSharedVideo', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveStream', id: string, playable: boolean, name: string }
          | { __typename?: 'Logo', id: string, playable: boolean, name: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'PdfDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'Swf', id: string, playable: boolean, name: string }
          | { __typename?: 'UnknownMedia', id: string, playable: boolean, name: string }
          | { __typename?: 'Video', id: string, playable: boolean, name: string }
         | null | undefined }> }
    | { __typename?: 'Video', id: string, hashedId: string, ietfLanguageTag?: string | null | undefined, localizations: Array<{ __typename?: 'MediaLocalization', id: string, ietfLanguageTag: string, languageName: string, nativeLanguageName: string, enabled: boolean, audioProvider: string, videoProvider: string, localizationIntent: string, createdAt: string, updatedAt: string, downloadUrl?: string | null | undefined, sourceMedia?:
          | { __typename?: 'Audio', id: string }
          | { __typename?: 'Avatar', id: string }
          | { __typename?: 'Document', id: string }
          | { __typename?: 'Image', id: string }
          | { __typename?: 'LiveSharedVideo', id: string }
          | { __typename?: 'LiveStream', id: string }
          | { __typename?: 'Logo', id: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string }
          | { __typename?: 'PdfDocument', id: string }
          | { __typename?: 'Swf', id: string }
          | { __typename?: 'UnknownMedia', id: string }
          | { __typename?: 'Video', id: string }
         | null | undefined, localizedMedia?:
          | { __typename?: 'Audio', id: string, playable: boolean, name: string }
          | { __typename?: 'Avatar', id: string, playable: boolean, name: string }
          | { __typename?: 'Document', id: string, playable: boolean, name: string }
          | { __typename?: 'Image', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveSharedVideo', id: string, playable: boolean, name: string }
          | { __typename?: 'LiveStream', id: string, playable: boolean, name: string }
          | { __typename?: 'Logo', id: string, playable: boolean, name: string }
          | { __typename?: 'MicrosoftOfficeDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'PdfDocument', id: string, playable: boolean, name: string }
          | { __typename?: 'Swf', id: string, playable: boolean, name: string }
          | { __typename?: 'UnknownMedia', id: string, playable: boolean, name: string }
          | { __typename?: 'Video', id: string, playable: boolean, name: string }
         | null | undefined }> }
   | null | undefined };


export const GetAlternateAudioLocalizationsDocument = gql`
    query GetAlternateAudioLocalizations($mediaHashedId: HashedId!) {
  media(hashedId: $mediaHashedId) {
    id
    hashedId
    ietfLanguageTag
    localizations {
      id
      ietfLanguageTag
      languageName
      nativeLanguageName
      enabled
      audioProvider
      videoProvider
      localizationIntent
      createdAt
      updatedAt
      downloadUrl
      sourceMedia {
        id
      }
      localizedMedia {
        id
        playable
        name
      }
    }
  }
}
    `;

/**
 * __useGetAlternateAudioLocalizationsQuery__
 *
 * To run a query within a React component, call `useGetAlternateAudioLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlternateAudioLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlternateAudioLocalizationsQuery({
 *   variables: {
 *      mediaHashedId: // value for 'mediaHashedId'
 *   },
 * });
 */
export function useGetAlternateAudioLocalizationsQuery(baseOptions: Apollo.QueryHookOptions<GetAlternateAudioLocalizationsQuery, GetAlternateAudioLocalizationsQueryVariables> & ({ variables: GetAlternateAudioLocalizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlternateAudioLocalizationsQuery, GetAlternateAudioLocalizationsQueryVariables>(GetAlternateAudioLocalizationsDocument, options);
      }
export function useGetAlternateAudioLocalizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlternateAudioLocalizationsQuery, GetAlternateAudioLocalizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlternateAudioLocalizationsQuery, GetAlternateAudioLocalizationsQueryVariables>(GetAlternateAudioLocalizationsDocument, options);
        }
export function useGetAlternateAudioLocalizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlternateAudioLocalizationsQuery, GetAlternateAudioLocalizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlternateAudioLocalizationsQuery, GetAlternateAudioLocalizationsQueryVariables>(GetAlternateAudioLocalizationsDocument, options);
        }
export type GetAlternateAudioLocalizationsQueryHookResult = ReturnType<typeof useGetAlternateAudioLocalizationsQuery>;
export type GetAlternateAudioLocalizationsLazyQueryHookResult = ReturnType<typeof useGetAlternateAudioLocalizationsLazyQuery>;
export type GetAlternateAudioLocalizationsSuspenseQueryHookResult = ReturnType<typeof useGetAlternateAudioLocalizationsSuspenseQuery>;
export type GetAlternateAudioLocalizationsQueryResult = Apollo.QueryResult<GetAlternateAudioLocalizationsQuery, GetAlternateAudioLocalizationsQueryVariables>;